import { render, staticRenderFns } from "./ModalB4.vue?vue&type=template&id=054f346e"
import script from "./ModalB4.vue?vue&type=script&lang=js"
export * from "./ModalB4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports